import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('rapid.StickyD');
    const { locale } = useRouter();
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: `.${css.comp}`,
                triggerHook: 1,
                offset: '150%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });
        }
    });

    return (
        <div className={css.comp}>
            <div className="sticky-box">
                <div className={`img-box ${enter ? 'enter' : ''}`}>
                    <EfImg
                        pc={
                            locale === 'jp'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1730686179411/pc_part04.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1729597137847/pc_part04.jpg'
                        }
                        h5={
                            locale === 'jp'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1730686179244/m_part04.jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1729597150352/m_part04.jpg'
                        }
                    />
                    <div className={`info ${enter ? 'enter' : ''}`}>
                        <p className="label">{t('label')}</p>
                        <p className="title">{t('title')}</p>
                        <p className="desc">{t('desc')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
